import {combineReducers, compose, createStore, applyMiddleware} from "redux";
import createSagaMiddleware from "@redux-saga/core";
import {logger, crashReporter} from "../../../store";
import rootSaga from "../sagas";

import {systemServerVersions, systemServerVersionsLoading} from "../reducers/systemServerVersions.reducer"

const SystemServerVersionsReducer = combineReducers({
    systemServerVersions, systemServerVersionsLoading
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
        name: "System Server Versions Store"
    })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const systemServerVersionsStore = createStore(
    SystemServerVersionsReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const SystemServerVersionsStoreSelectors = {
    systemServerVersions: (state = systemServerVersionsStore.getState()) => state.systemServerVersions,
    systemServerVersionsLoading: (state = systemServerVersionsStore.getState()) => state.systemServerVersionsLoading
};

sagaMiddleware.run(rootSaga);
